module.exports = __webpack_public_path__ + "536b1774e3e7ded50b9417a59baa40bc.woff";